import type { FC } from 'react';
import { cn } from '@/utils/cn.ts';
import headerData from '@/data/header.json';

export const Navigation: FC = () => {
  return (
    <nav className="flex space-x-8">
      {headerData.navigation.map((item) => (
        <a
          key={item.label}
          href={item.href}
          className={cn(
            'text-sm font-semibold uppercase tracking-wide transition-colors py-2 px-1',
            'hover:text-red-600 border-b-2 border-transparent hover:border-red-600',
            item.isActive 
              ? 'text-red-600 border-red-600' 
              : 'text-gray-700'
          )}
        >
          {item.label}
        </a>
      ))}
    </nav>
  );
};